export const handleRefresh = async (
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>,
  logout: () => Promise<void>
) => {
  setIsOpen(false);
  sessionStorage.clear();
  await logout();
};
